import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user.model';
import { URL_SERVICES, URL_FRONTEND } from '../../config/config';
import { Router } from '@angular/router';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { UploadService } from '../upload/upload.service';

@Injectable()
export class UserService {

  token: string;
  user: User;
  menu: any;

  constructor( public http: HttpClient, public router: Router, public _uploadService: UploadService ) {
    this.loadStorage();
  }

  saveStorage ( id: string, token: string, user: User, menu: any ) {
    localStorage.setItem('id', id),
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify( user ) );
    localStorage.setItem('menu', JSON.stringify( menu ) );

    this.token = token;
    this.user = user;
    this.menu = menu;

  }

  isLoged () {
    // Si existe token esta creado entonces esta logueado
    return ( this.token.length > 5 ) ? true : false;
  }

  loadStorage() {
    if ( localStorage.getItem('token') ) {
      this.token = localStorage.getItem('token');
      this.user = JSON.parse( localStorage.getItem('user') );
      this.menu = JSON.parse( localStorage.getItem('menu') );
    } else {
      this.token = '';
      this.user = null;
      this.menu = null;
    }
  }

  login(user: User, rememberme: boolean ) {
    // tslint:disable-next-line:prefer-const
    let url = URL_SERVICES + '/login';

    // Si el rememberme esta activado, guardo el email en el localStorage para obtenerlo despues
    if (rememberme) {
      localStorage.setItem('email', user.email);
    } else {
      localStorage.removeItem('email');
    }
    // Hago la peticion post del login y uso el map para obtener la respuesta y guardarla en el local storage
    return this.http.post(url, user)
                    .map((res: any) => {
                        this.saveStorage(res.id, res.token, res.user, res.menu);
                        return true;
                    })
                    .catch(err => {
                      // Obtengo el error desde el servidor y lo muestro en un mensaje
                      console.log(err);
                      swal('Error en el Login', err.error.message, 'error');
                      return Observable.throw(err);
                    });
  }

  recuperarPassword(email: string) {
    // tslint:disable-next-line:prefer-const
    let url = URL_SERVICES + '/login/recuperarpassword';

    let link: string = URL_FRONTEND + '/#/recuperar-password';

    let object: any = {
      email: email,
      link: link
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      } else {
        swal('Email Incorrecto', 'El email ingresado no es correcto, intente nuevamente. Gracias.', 'error');
      }
      return Observable.throw(err);
    });
  }

  validarRecuperarPassword(email: string, codRecuperacion: string, nuevoPassword: string) {
    // tslint:disable-next-line:prefer-const
    let url = URL_SERVICES + '/login/validarcodrecuperacion';

    let object: any = {
      email: email,
      codRecuperacion: codRecuperacion,
      nuevoPassword: nuevoPassword
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      } else {
        swal('Datos Incorrecto', 'Los datos para el cambio de contraseña son incorrectos, intente nuevamente. Gracias.', 'error');
      }
      return Observable.throw(err);
    });
  }

  logout() {
    this.token = '';
    this.user = null;
    this.menu = null;

    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('menu');

    this.router.navigate(['/login']);
  }

  actualizarUsuario() {
    let url = URL_SERVICES + '/user/getuser/' + this.user._id;

    this.http.get(url).subscribe((resp: any) => {
      this.user = resp.user;
      this.saveStorage(this.user._id, this.token, this.user, this.menu);
    });
  }

  getUserActividades() {
    let url = URL_SERVICES + '/user/getuseractividades/' + this.user._id;

    return this.http.get(url).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getGananciasPorCategArg(congreso_id: string) {
    let url = URL_SERVICES + '/user/gananciasporcateg/arg/' + congreso_id + '?token=' + this.token;

    return this.http.get(url).map((resp: any) => {
      return resp.result;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getGananciasPorCategUsd(congreso_id: string) {
    let url = URL_SERVICES + '/user/gananciasporcateg/usd/' + congreso_id + '?token=' + this.token;

    return this.http.get(url).map((resp: any) => {
      return resp.result;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getGananciasPorActivArg(congreso_id: string) {
    let url = URL_SERVICES + '/user/gananciasporactiv/arg/' + congreso_id + '?token=' + this.token;

    return this.http.get(url).map((resp: any) => {
      return resp.result;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getGananciasPorActivUsd(congreso_id: string) {
    let url = URL_SERVICES + '/user/gananciasporactiv/usd/' + congreso_id + '?token=' + this.token;

    return this.http.get(url).map((resp: any) => {
      return resp.result;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  crearInscripcion(user: User) {
    let url = URL_SERVICES + '/user/inscripcion';
    return this.http.post(url, user).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  subirArchivo (file: File, id: string, datosFacturacion: any) {
    // Llama al servicio para subir el archivo para el tipo usuarios
    return this._uploadService.uploadFile(file, id);
  }

  getUsuariosPorCongreso( desde: number, limit: number, congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/' + congreso + '?from=' + desde + '&limit=' + limit + '&token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCursosUsuario() {
    let url = URL_SERVICES + '/user/inscriptos/actividades/cursos/' + this.user._id + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosPendientesPago( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/pendientespago/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosPendientesAprobacion( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/pendientesaprobacion/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosAprobados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/aprobados/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosInvitados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/invitados/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosTrabajosPresentados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/presentado/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosTrabajosInvitadosPresentados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/invitados/presentado/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosTrabajosAprobados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/aprobado/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosTrabajosRechazados( congreso: string, limit: number, from: number ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/rechazado/' + congreso + '?token=' + this.token + '&limit=' + limit + '&from=' + from;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCantidadTrabajosPresentados( congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/presentado/count/' + congreso + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCantidadTrabajosInvitadosPresentados( congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/invitados/presentado/count/' + congreso + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCantidadTrabajosAprobados( congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/trabajos/aprobado/count/' + congreso + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCantidadTotalInscriptos( congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/count/' + congreso + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getCantidadInscriptosAprobados( congreso: string ) {
    let url = URL_SERVICES + '/user/inscriptos/aprobados/count/' + congreso + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  buscarInscriptos(busqueda: string, congreso_id: string) {
    let url = URL_SERVICES + '/user/inscriptos/buscar/' + congreso_id + '/' + busqueda + '?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  aprobarPago(id: string) {
    let url = URL_SERVICES + '/user/aprobarpago/' + id + '?token=' + this.token;
    return this.http.put(url, {}).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  aprobarTrabajo(id: string) {
    let url = URL_SERVICES + '/user/aprobartrabajo/' + id + '?token=' + this.token;
    return this.http.put(url, {}).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  rechazarTrabajo(id: string) {
    let url = URL_SERVICES + '/user/rechazartrabajo/' + id + '?token=' + this.token;
    return this.http.put(url, {}).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  getUsuariosAdmin() {
    let url = URL_SERVICES + '/user?token=' + this.token;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  guardarUsuarioAdmin( user: User ) {
    let url = URL_SERVICES + '/user';
    if ( user._id ) {
      url = url + '/' + user._id + '?token=' + this.token;

      return this.http.put(url, user).map((resp: any) => {
        return resp.actividad;
      })
      .catch(err => {
        console.log(err);
        if (err.status === 401) {
          swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
          this.logout();
        }
        return Observable.throw(err);
      });
    } else {
      url = url + '?token=' + this.token;

      return this.http.post(url, user).map((resp: any) => {
        return resp.actividad;
      })
      .catch(err => {
        console.log(err);
        if (err.status === 401) {
          swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
          this.logout();
        }
        return Observable.throw(err);
      });
    }
  }

  deleteUsuariosAdmin(user: User) {
    let url = URL_SERVICES + '/user/' + user._id + '?token=' + this.token;

    return this.http.delete(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  deleteInscripto(user: User) {
    let url = URL_SERVICES + '/user/' + user._id + '?token=' + this.token;

    return this.http.delete(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  actualizarDatosFacturacion(user: User, datosFacturacion: any) {
    let url = URL_SERVICES + '/user/facturacion/' + user._id + '?token=' + this.token;

    return this.http.post(url, datosFacturacion)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  registrarPagoPaypal(user: User, payment: any, categoriaInscripcion: any, actividades: any[], total: number) {
    let url = URL_SERVICES + '/user/paypal/pago/' + user._id + '?token=' + this.token;

    let paypalIdPago: string;
    console.log(payment);
    if (payment.manual) {
      if (payment.idPaypal === '') {
        paypalIdPago = 'manual';
      } else {
        paypalIdPago = payment.idPaypal;
      }
    } else {
      paypalIdPago = payment.transactions[0].related_resources[0].sale.id;
    }
    console.log(paypalIdPago);

    let object: any = {
      paypalIdPago: paypalIdPago,
      categoriaInscripcion: categoriaInscripcion,
      actividades: actividades,
      total: total
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this.logout();
      }
      return Observable.throw(err);
    });
  }

  cambiarPassword(user: User, passwordAnterior: string, passwordNuevo: string) {
    let url = URL_SERVICES + '/user/cambiarpassword?token=' + this.token;

    let object: any = {
      email: user.email,
      password: passwordAnterior,
      passwordNuevo: passwordNuevo
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 406) {
        swal('Contraseña Actual incorrecta', 'La contraseña ingresada es incorrecta. Intente nuevamente.', 'error');
      }
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts